import React from "react";
import { observer } from "mobx-react-lite";
import { Grid } from "@mui/material";
import Player from "../../../components/video-player/Player";
import VideoPlayer from "e.sic-platform.webclient/src/components/video-player/VideoPlayer";
import { AnalysisService } from "e.sic-platform.webclient/src/services/analysis/AnalysisService";

interface IVideoAnalysisPlayerSectionProps {
    videoAnalysis: AnalysisService;
}

export default observer(function VideoAnalysisPlayerSection(props: IVideoAnalysisPlayerSectionProps) {
    const { videoAnalysis } = props;
    return (
        <>
            <Grid item xs={12} sm={12} xl={8}>
            {videoAnalysis.video !== undefined && (
              <Player service={videoAnalysis}>
                {videoAnalysis?.video!.isAvailable && <VideoPlayer enableControls />}
              </Player>
            )}
        </Grid>
        
        </>
    );
  });